<template>
    <modal
        v-if="show"
        class="complianceModal"
        :size="'is-small'"
        :title="titleModal"
        :submitText="submitText"
        :cancelText="'Cancel'"
        :backText="'Back'"
        :submitClasses="{
            'is-primary': true,
            'is-busy': isLoading,
        }"
        :hideBack="!showBackButton"
        :hideCancel="!showCancelButton"
        :submitDisabled="isSubmitDisabled"
        :hideHeader="isFormSuccessful"
        :hideFoot="isFormSuccessful"
        @back="prevStep"
        @closed="handleClosed"
        @submit="handleSubmit"
    >
        <configuration-stepper
            v-if="!loading && isShowStepper"
            :type="'simple'"
            :currentStep="currentStep"
            :steps="steps"
        />
        <div class="complianceModal__content">
            <div v-if="isShowInfo" class="center">
                <template>
                    <div class="info">
                        <fa-icon icon="info-circle" />
                    </div>
                    <h3 class="title">
                        <template v-if="isFirstTollFreeNumber">
                            Add toll-free number first
                        </template>
                        <template v-else> All toll-free numbers verified </template>
                    </h3>

                    <p class="description">
                        <template v-if="isFirstTollFreeNumber">
                            To get access to Toll-Free verification you need to first add a
                            toll-free number.
                        </template>
                        <template v-else>
                            Buy more toll-free numbers and resubmit for verification to avoid
                            carrier filtering and ensure better deliverability.
                        </template>
                    </p>
                </template>
            </div>
            <div v-if="isShowChooseNumber" class="tollFreeAddNumber">
                <template>
                    <template v-if="form.number_vendor_id !== aircall_id">
                        <form-error-message
                            v-if="form.errors.get('number')"
                            :form="form"
                            hide-close
                        >
                            {{ form.errors.get('number') }}
                        </form-error-message>
                        <form-error-message
                            v-else-if="form.errors.get('form')"
                            :form="form"
                            hide-close
                        >
                            {{ form.errors.get('form') }}
                        </form-error-message>
                        <form-error-message
                            v-else-if="form.errors.get('stripe')"
                            :form="form"
                            hide-close
                        >
                            {{ form.errors.get('stripe') }}
                        </form-error-message>
                    </template>
                    <div class="complianceModal__title">Choose number</div>
                    <form-message
                        type="is-info"
                        :isHtml="true"
                        icon="info-circle"
                        message="<a href=&quot;&quot; target=&quot;_blank&quot;>You are required by the carriers to verify your toll-free numbers.</a><br/><br/>
                                    To avoid carrier filtering and ensure better deliverability, after adding the number, please complete the
                                    <a href=&quot;&quot; target=&quot;_blank&quot;>toll-free verification. Learn more</a>."
                    />
                    <div class="number-picker">
                        <div
                            v-if="numbers !== null && numbers.length"
                            class="number-results__numbers"
                        >
                            <div
                                v-for="(chunk, index) in chunked"
                                :key="index"
                                class="columns number-results"
                            >
                                <div
                                    v-for="number in chunk"
                                    :key="number.id"
                                    class="column is-narrow"
                                >
                                    <form-radio
                                        v-model="form.number"
                                        :value="number.number"
                                        :disabled="form.busy"
                                    >
                                        {{ number.formatted }}
                                    </form-radio>
                                </div>
                            </div>
                        </div>
                        <div class="number-picker__wrapBtn">
                            <button class="button" :disabled="searchForm.busy" @click="search()">
                                Refresh numbers
                            </button>
                        </div>
                    </div>
                </template>
            </div>
            <div v-if="isShowAssignInbox">
                <form-message
                    v-if="form.errors.has('stripe')"
                    :type="'is-danger'"
                    :message="form.errors.get('stripe')"
                />
                <form-message
                    v-else-if="form.errors.has('number')"
                    :type="'is-danger'"
                    :message="form.errors.get('number')"
                />
                <form-message
                    v-else-if="form.errors.any()"
                    :type="'is-danger'"
                    message="Something went wrong, please try again."
                />
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label"> Assign Inbox </label>
                            <form-dropdown
                                v-model="assignInbox"
                                label=""
                                placeholder="Select"
                                :settings="{
                                    maxItems: 1,
                                    dropdownParent: 'body',
                                }"
                            >
                                <option :key="`usr-int-1`" value="assign-new">
                                    Create & Assign a New Inbox
                                </option>
                                <option :key="`usr-int-2`" value="assign-existing">
                                    Assign Existing Inbox
                                </option>
                                <option :key="`usr-int-3`" value="assign-later">
                                    Assign Inbox Later
                                </option>
                            </form-dropdown>
                        </div>
                        <div v-if="assignInbox === 'assign-existing'" class="field">
                            <label class="label"> Choose Inbox </label>
                            <form-dropdown
                                v-model="selectedInboxId"
                                label=""
                                placeholder="Select"
                                :settings="{
                                    maxItems: 1,
                                    dropdownParent: 'body',
                                }"
                            >
                                <option
                                    v-for="inbox in inboxesOptions"
                                    :key="inbox.id"
                                    :value="inbox.id"
                                >
                                    {{ inbox.name }}
                                </option>
                            </form-dropdown>
                        </div>
                        <template v-if="assignInbox === 'assign-new'">
                            <div class="field">
                                <label class="label"> Inbox Name </label>
                                <form-input
                                    v-model="form.name"
                                    type="text"
                                    :min="3"
                                    placeholder="Enter Inbox Name"
                                    :error="form.errors.get('name')"
                                />
                            </div>
                            <div class="field">
                                <label class="label"> Inbox Owner </label>
                                <form-dropdown
                                    v-model.number="form.owner.id"
                                    label=""
                                    placeholder="Select"
                                    :error="form.errors.get('owner')"
                                    :settings="{
                                        maxItems: 1,
                                        dropdownParent: 'body',
                                    }"
                                >
                                    <option
                                        v-for="member in filterOwners"
                                        :key="member.id"
                                        :value="member.id"
                                    >
                                        {{ member.full_name }}
                                    </option>
                                </form-dropdown>
                            </div>
                            <div class="field">
                                <label class="label"> Additional Members </label>
                                <form-dropdown
                                    v-if="members.length"
                                    :key="'dropdown-add'"
                                    ref="dropdown"
                                    :form="form"
                                    placeholder="Add Additional Members"
                                    dropdown-class="selectize-contacts"
                                    :settings="dropdownSettings"
                                    label=""
                                    :error="form.errors.get('members')"
                                    :disabled="form.busy"
                                    class="tagsApplyOrRemove"
                                    @input="handleChangeMultiSelect"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div v-if="billing === null" class="help">
                <basic-loader center aria-label="TollFreeAddNumberModal" />
            </div>
            <div v-else-if="isShowChooseNumber || isShowAssignInbox" class="tooltip-parent">
                <span>Today you will</span>
                <template v-if="proratedAmount && proratedAmount > 0">
                    be charged
                    <span
                        v-tooltip.top="priceTooltip"
                        class="price-text"
                        @mouseenter="showPriceTooltip"
                        @mouseleave="hidePriceTooltip"
                    >
                        ${{ proratedAmount }}
                    </span>
                    for the discounted pro-rated cost of
                </template>
                <template v-else> not be charged for </template>
                a new number.
            </div>
            <modal-alert-success v-if="isFormSuccessful"> Number Added </modal-alert-success>
        </div>
    </modal>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import Form from 'core/Form';
import OrganizationMixin from 'mixins/organization';
import CardsMixin from 'mixins/cards';
import { filter } from 'lodash';
import EarlyUpgradeMixin from 'mixins/early-upgrade';

const MODAL_TYPES = {
    INFO: 1,
    CHOOSE_NUMBER: 2,
    ASSIGN_INBOX: 3,
};

export default {
    mixins: [CardsMixin, OrganizationMixin, EarlyUpgradeMixin],

    emits: ['closed', 'submit'],

    data() {
        return {
            loading: false,
            steps: 2,
            currentStep: 1,
            MODAL_TYPE: MODAL_TYPES.INFO,
            MODAL_TYPES: MODAL_TYPES,
            showBackButton: false,
            showCancelButton: true,
            numbersSearch: null,
            assignInbox: null,
            selectedInboxId: null,
            billing: null,
            aircall_id: null,
            twilio_id: null,
            inteliquent_id: null,
            tollFreeProfileId: '',
            searchForm: new Form(
                {
                    country: 'US',
                    search: '',
                    toll_free: '1',
                },
                false,
                false
            ),
            form: new Form(
                {
                    name: '',
                    members: null,
                    number: '',
                    vendor_id: '',
                    number_vendor_id: null,
                    owner: {
                        id: null,
                    },
                },
                false
            ),
            formCard: new Form(
                {
                    name: '',
                    email: '',
                    token: '',
                    primary: false,
                    backup: false,
                    type: 'default',
                    confirm: false,
                },
                false
            ),
            formTollFree: new Form(
                {
                    numbers: [],
                },
                false,
                false
            ),
            priceTooltipIsShown: false,
            disabledPaymentMethod: false,
        };
    },

    computed: {
        titleModal() {
            switch (this.MODAL_TYPE) {
                case MODAL_TYPES.INFO:
                    return this.isFirstTollFreeNumber
                        ? 'Add toll-free number'
                        : 'All toll-free number';
                default:
                    return 'Buy number';
            }
        },

        submitText() {
            switch (this.MODAL_TYPE) {
                case MODAL_TYPES.INFO:
                    return this.isFirstTollFreeNumber ? 'Add number' : 'Buy number';
                case MODAL_TYPES.CHOOSE_NUMBER:
                    return 'Continue';
                case MODAL_TYPES.ASSIGN_INBOX:
                    return 'Purchase number';
                default:
                    return 'Done';
            }
        },

        isShowInfo() {
            return this.MODAL_TYPE === MODAL_TYPES.INFO && !this.isFormSuccessful;
        },

        isShowChooseNumber() {
            return this.MODAL_TYPE === MODAL_TYPES.CHOOSE_NUMBER && !this.isFormSuccessful;
        },

        isShowAssignInbox() {
            return this.MODAL_TYPE === MODAL_TYPES.ASSIGN_INBOX && !this.isFormSuccessful;
        },

        isShowStepper() {
            return (this.isShowChooseNumber || this.isShowAssignInbox) && !this.isFormSuccessful;
        },

        isSubmitDisabled() {
            return (
                (!this.form.number && this.isShowChooseNumber) ||
                (this.isShowAssignInbox && this.isAssignInboxSelected) ||
                this.isLoading
            );
        },

        isFormSuccessful() {
            return this.form && this.form.successful;
        },

        isAssignInboxSelected() {
            if (!this.assignInbox) {
                return true;
            } else if (this.assignInbox === 'assign-existing' && !this.selectedInboxId) {
                return true;
            } else if (this.assignInbox === 'assign-new' && this.form.name === '') {
                return true;
            }

            return false;
        },

        chunked() {
            return !this.numbersSearch
                ? []
                : this.numbersSearch.slice(0, -3).reduce((arr, item, idx) => {
                      return idx % 3 === 0
                          ? [...arr, [item]]
                          : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]];
                  }, []);
        },

        isLoading() {
            return Boolean(
                this.form.busy ||
                    this.formCard.busy ||
                    this.searchForm.busy ||
                    this.formTollFree.busy
            );
        },

        dropdownSettings() {
            return {
                valueField: 'id',
                searchField: ['full_name'],
                options: this.members,
                highlight: true,
                render: {
                    item: this.dropdownMembersItem,
                    option: this.dropdownMembersOption,
                },
                maxItems: null,
                dropdownParent: 'body',
            };
        },

        dropdownSettingsTollFreeProfile() {
            const options = this.tollFreeProfileItems
                .filter((item) => item.completed)
                .map((item) => ({
                    id: item.id,
                    label: item.title,
                }));

            return {
                maxItems: 1,
                options: options,
                valueField: 'id',
                highlight: false,
                searchField: ['label'],
                render: {
                    item: this.dropdownTollFreeItem,
                    option: this.dropdownTollFreeOption,
                },
                dropdownParent: 'body',
            };
        },

        proratedAmount() {
            if (this.billing?.prorated_amount) {
                return (this.billing.prorated_amount / 100).toFixed(2).toString();
            }

            return null;
        },

        priceTooltip() {
            return {
                show: this.priceTooltipIsShown,
                triggers: [],
                container: '.tooltip-parent',
                content:
                    'Was the last inbox a different price? <a target=\'_blank\' href=\'https://help.salesmessage.com/en/articles/5581309-inboxes-costs-explained\'>Learn more</a>',
            };
        },

        inboxesOptions() {
            return filter(this.inboxesSettingsArray, (item) => !item.number.is_aircall);
        },

        selectedTollFreeProfile() {
            return this.tollFreeProfileItems.find((item) => item.id === +this.tollFreeProfileId);
        },

        filterOwners() {
            return this.members.filter((item) => !item.isViewOnlyRole);
        },

        show() {
            return this.showTollFreeAddNumberModal;
        },

        getAllTollFreeNumbers() {
            return [
                ...this.numbers.filter((item) => item.isTollFree),
                ...this.unassignedNumbers.filter((item) => item.isTollFree),
            ];
        },

        isFirstTollFreeNumber() {
            return !this.getAllTollFreeNumbers?.length;
        },

        ...mapState(stores.User, ['user']),
        ...mapState(stores.BillingSources, ['billingSources']),
        ...mapState(stores.ComplianceProfile, ['tollFreeProfileItems']),
        ...mapState(stores.Inboxes, ['inboxesSettingsArray']),
        ...mapState(stores.Members, ['members']),
        ...mapState(stores.Number, ['numbers', 'unassignedNumbers']),
        ...mapState(stores.TollFreeStore, [
            'showTollFreeAddNumberModal',
            'tollFreeAddNumberModalCallback',
        ]),
    },

    watch: {
        show(value) {
            if (value) {
                this.init();
            }
        },

        isShowInfo(status) {
            if (status && this.form.number_vendor_id === null) this.init();
        },

        isShowChooseNumber(status) {
            if (status && !this.numbersSearch?.length) {
                this.search();
            }
        },

        'form.successful'(val) {
            if (val) {
                this.closeTimeout = setTimeout(() => {
                    this.onSubmit();
                    this.reset();
                }, 1500);
            } else {
                clearTimeout(this.closeTimeout);
            }
        },
    },

    methods: {
        async init() {
            await Promise.all([
                this.loadBilling(),
                this.loadNumberVendors(),
                this.$store.dispatch('getTeams'),
            ]);
        },

        async loadBilling() {
            try {
                this.billing = null;

                const params = {
                    params: {
                        plan: this.planSharedInboxesPlanId || this.planId,
                        inboxes: 1,
                    },
                };

                this.billing = await this.$store.dispatch(
                    'getBillingPreviewSharedInboxesMicroservice',
                    params
                );
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'loadBilling');
            }
        },

        async loadNumberVendors() {
            try {
                const response = await this.$store.dispatch('getNumbersVendors');

                this.numberVendors = response.data;

                this.aircall_id = this.numberVendors.find((o) => o.key === 'aircall-api')
                    ? this.numberVendors.find((o) => o.key === 'aircall-api').id
                    : null;
                this.twilio_id = this.numberVendors.find((o) => o.key === 'twilio')
                    ? this.numberVendors.find((o) => o.key === 'twilio').id
                    : null;
                this.inteliquent_id = this.numberVendors.find((o) => o.key === 'inteliquent')
                    ? this.numberVendors.find((o) => o.key === 'inteliquent').id
                    : null;

                this.form.number_vendor_id = this.inteliquent_id
                    ? this.inteliquent_id
                    : this.twilio_id;
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'loadNumberVendors');
            }
        },

        async updateAppState() {
            await this.$store.dispatch('getNumbers', { search: true });
            await this.$store.dispatch('getNumbersUnassigned', { search: true });
            await this.$store.dispatch('getUserMe');
        },

        async handleFinish() {
            try {
                let response = [];
                let number = null;

                if (this.assignInbox === 'assign-existing') {
                    response = await this.$store.dispatch('updateTeamsByIdNumbers', {
                        form: this.form,
                        id: this.selectedInboxId,
                    });

                    number = response.find((item) => item.number === this.form.number);
                } else if (this.assignInbox === 'assign-new') {
                    response = await this.$store.dispatch('createTeams', this.form);
                    number = response.number;
                } else if (this.assignInbox === 'assign-later') {
                    number = await this.$store.dispatch('updateNumbersUnassignedCreate', this.form);
                    response = number;
                }

                if (this.selectedTollFreeProfile) {
                    await this.handleAddNumberTollFree(number);
                }

                await this.updateAppState();
            } catch (e) {
                const data = e?.response?.data;

                if (data) {
                    this.form.errors.record(data);
                }

                this.$log.error(e, this.$options.__file, 'handleFinish');
            }
        },

        async handleAddNumberTollFree(number) {
            try {
                this.formTollFree.numbers = [
                    ...this.selectedTollFreeProfile.numbers.map((item) => item.id),
                    number.id,
                ];

                await this.$store.dispatch('updateTollFreeProfile', {
                    form: this.formTollFree,
                    id: this.selectedTollFreeProfile.id,
                });
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleAddNumberTollFree');
            }
        },

        prevStep() {
            if (this.isShowChooseNumber) {
                this.currentStep--;
                this.MODAL_TYPE = MODAL_TYPES.INFO;
                this.showBackButton = false;
                this.showCancelButton = true;
                this.assignInbox = null;
                this.selectedInboxId = null;

                return;
            }

            if (this.isShowAssignInbox) {
                this.MODAL_TYPE = MODAL_TYPES.CHOOSE_NUMBER;
                this.currentStep--;
                this.assignInbox = null;
                this.selectedInboxId = null;
            }
        },

        onSubmit() {
            if (this.tollFreeAddNumberModalCallback) {
                this.tollFreeAddNumberModalCallback?.();
                this.$store.dispatch('handleShowTollFreeAddNumberModal', {
                    status: false,
                });
            } else {
                this.$store.dispatch('handleShowTollFreeAddNumberModal', {
                    status: false,
                });
                this.$store.dispatch('handleShowTollFreeVerificationModal', {
                    status: true,
                });
                this.$emit('submit');
            }
        },

        handleSubmit() {
            if (this.isShowInfo) {
                if (!this.user.isPftTrialFlow) {
                    if (
                        (this.isOnTrial || this.checkLegacyAccess || this.checkPlanFreeMonthly) &&
                        !this.isFirstTollFreeNumber
                    ) {
                        this.showEarlyUpgrade();

                        return;
                    }
                }

                if (this.user.isPftTrialFlow && this.isOnTrial && this.isFirstTollFreeNumber) {
                    this.showEarlyUpgrade();

                    return;
                }

                this.MODAL_TYPE = MODAL_TYPES.CHOOSE_NUMBER;
                this.showCancelButton = false;
                this.showBackButton = true;

                return;
            }

            if (this.isShowChooseNumber) {
                this.MODAL_TYPE = MODAL_TYPES.ASSIGN_INBOX;
                this.currentStep++;

                return;
            }

            if (this.isShowAssignInbox) {
                this.showBackButton = false;
                this.handleFinish();
            }
        },

        handleClosed() {
            this.$store.dispatch('handleShowTollFreeAddNumberModal', {
                status: false,
            });
            this.$emit('closed');
            this.reset();
        },

        reset() {
            this.currentStep = 1;
            this.MODAL_TYPE = MODAL_TYPES.INFO;
            this.showBackButton = false;
            this.showCancelButton = true;
            this.assignInbox = null;
            this.selectedInboxId = null;
            this.form.reset();
            this.searchForm.reset();
            this.formCard.reset();
            this.formTollFree.reset();
            this.numbersSearch = null;
        },

        async search() {
            if (this.searchForm.busy) return;

            this.form.errors.clear();
            this.searchForm.errors.clear();
            this.form.number = '';

            if (!(this.searchForm.search.length && this.searchForm.search.length < 3)) {
                try {
                    const response = await this.$store.dispatch(
                        'updateNumbersSearch',
                        this.searchForm
                    );
                    this.numbersSearch = response.data;

                    if (!this.numbersSearch.length) {
                        this.form.errors.record({
                            number: [`No numbers available for ${this.searchForm.search}.`],
                        });
                    }
                } catch (e) {
                    this.numbersSearch = null;
                    this.$log.error(e, this.$options.__file, 'search');
                }
            }
        },

        handleChangeMultiSelect(data) {
            this.form.members = data;
        },

        showPriceTooltip() {
            this.priceTooltipIsShown = true;
        },

        hidePriceTooltip() {
            setTimeout(() => {
                this.priceTooltipIsShown = false;
            }, 1000);
        },

        priceTooltipLeave() {
            setTimeout(this.hidePriceTooltip, 7000);
        },

        dropdownMembersItem(item) {
            return `<div class='selectize-contact tag is-small' style='background-color: #1d96f3; color: white;'>
                        ${item.full_name}
                    </div>`;
        },

        dropdownMembersOption(item) {
            return `<div class='selectize-contact'>
                        <div class='selectize-contact-info'>
                            <strong>${item.full_name}</strong>
                        </div>
                    </div>`;
        },

        dropdownTollFreeItem(item, escape) {
            return `<div class='selectize-contact'>
                        ${escape(item.label)}
                    </div>`;
        },

        dropdownTollFreeOption(item, escape) {
            return `<div class='selectize-contact'>
                        <div class='selectize-contact-info'>
                            <span>${escape(item.label)}</span>
                        </div>
                    </div>`;
        },
    },
};
</script>
